module.exports = __webpack_public_path__ + "static/media/external-link-icon-gray.2d8ec74e.svg";